// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Privacy h2 { margin-bottom: 82px\n}\n.Privacy p {\n    max-width: 700px;\n\n    line-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
